import { createFileRoute } from "@tanstack/react-router";

import { DevelopersScreen } from "../features/developers/DevelopersScreen.tsx";

export const Route = createFileRoute("/_app/developers")({
  component: DevelopersScreen,
});
